module.exports = __webpack_public_path__ + "img/L.5abc1d50.webp";